import React, {useEffect, useState} from 'react'
import IconButton from '@mui/material/IconButton'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'
import {useMutation} from "@apollo/client"
import {DELETE_FAVORITE, ADD_FAVORITE} from "./graphql"
import {useSelector, useDispatch} from "react-redux"
import {setLoginModal} from "../../../slice"

function FavoriteButton(props) {
    const {active, nid} = props

    const [isActive, setActive] = useState()
    const dispatch = useDispatch()
    const authenticated = useSelector(state => state.global.user.authenticated)

    useEffect(() => {
        setActive(active)
    }, [active])

    const [addFavorite] = useMutation(ADD_FAVORITE,
        {
            onCompleted: ({addFavoriteToLibrary}) => {
                if (addFavoriteToLibrary.result.success === true) {
                    setActive(true)
                }
            }
        }
    )
    const [deleteFavorite] = useMutation(DELETE_FAVORITE,
        {
            onCompleted: ({deleteFavorite}) => {
                if (deleteFavorite.result.success === true) {
                    setActive(false)
                }
            }
        }
    )

    const handleClick = () => {
        if (authenticated) {
            if (isActive) {
                deleteFavorite(
                    {variables: {nid: nid}}
                )
            } else {
                addFavorite({variables: {nid: nid}})
            }
        } else {
            dispatch(setLoginModal(true))
        }
    }

    return (
        <>
            {isActive ?
                <IconButton
                    onClick={handleClick}
                    aria-label='add to favorites'
                    sx={{padding: 0, marginRight: 1}}
                >
                    <FavoriteIcon/>
                </IconButton>

                :
                <IconButton
                    onClick={handleClick}
                    aria-label='remove from favorites'
                    sx={{padding: 0, marginRight: 1}}
                >
                    <FavoriteBorderIcon/>
                </IconButton>
            }
        </>
    )
}

export default FavoriteButton